import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
import { DROPS_DEFAULT_TAB } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
export default function getLogoutUrl() {
    const dropsUrl = routeUrls.drops({
        tab: DROPS_DEFAULT_TAB,
    });
    return `${dropsUrl}&logout=true`;
}
